import styled from 'styled-components'

// EmployeePremiumTable

export const TableHeader = styled.th`
  color: var(--primary);
  font-size: 20px;
  font-weight: 600;
  padding: 10px 20px;
`

// MainTableRow

export const MainRow = styled.tr`
  :hover {
    cursor: pointer;
  }
`

export const MainTableCell = styled.td`
  font-size: 16px;
  padding: 10px 20px;
`
// CollapsibleTableRow

export const InnerTableHeader = styled.th`
  font-weight: 700;
  font-size: 16px;
  padding: 5px 20px;
  text-align: right;
`

// PlanDetailsRow

export const InnerTableCell = styled.td`
  padding: 10px 20px;
  vertical-align: top;
`

export const InnerTableText = styled.p`
  margin: 2px 5px;
  text-align: right;
`

export const InnerTableSubheader = styled.p`
  margin: 2px 5px;
  text-align: left;
`
